<template>
  <common-layout-history-template :isBread="true" :breadHeading="'最近見た物件'">
    <template v-slot:body>
      <view-history-contents v-if="viewHistoryReady"/>
    </template>
  </common-layout-history-template>
</template>

<script>
import ViewHistoryContents from '@/components/history/view/ViewHistoryContents';
import CommonLayoutHistoryTemplate from '@/components/templates/CommonLayoutHistoryTemplate';

const canonical = location.href.match(/\/$/) === null ? `${location.href}/` : location.href;


export default {
  name: 'ViewHistory',
  metaInfo() {
    return {
      link: [
        { rel: 'canonical', href: canonical },
      ],
    };
  },
  components: {
    ViewHistoryContents,
    CommonLayoutHistoryTemplate,
  },
  data() {
    return {

    };
  },
  computed: {
    viewHistoryReady() {
      return this.$store.getters['getViewHistory'].data;
    },
  },
  created() {

  },
  methods: {

  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";
</style>
